import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { MotionConfig } from 'motion/react'
import { Bricolage_Grotesque, JetBrains_Mono } from 'next/font/google'
import Cursor from '@/components/generals/cursor'
import SmoothScroll from '@/components/generals/smooth-scroll'

const sans = Bricolage_Grotesque({
    subsets: ['latin'],
    axes: ['opsz', 'wdth']
})

const mono = JetBrains_Mono({
    subsets: ['latin']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${sans.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <MotionConfig reducedMotion='user'>
                <SmoothScroll />
                <Component {...pageProps} />
                <Cursor />
            </MotionConfig>
        </div>
    )
}

export default App
